<template>
  <v-container fluid>
    <v-row>
      <template>
        <div class="text-center">
          <v-snackbar
            v-model="showNotification"
            :timeout="8000"
            :value="true"
            :color="
              notifyLevel == 'info'
                ? 'blue-grey lighten-2'
                : 'yellow lighten-3 blue-grey--text'
            "
            right
            rounded="pill"
            top
          >
            {{ notifyMessage }}
          </v-snackbar>
        </div>
      </template>
      <v-col>
        <div>
          <v-toolbar light flat>
            <v-toolbar-title
              >Errors Manager
              <div class="text-sm-caption mb-3">{{ total }} error messages</div>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar flat class="shrink" dense>
              <v-text-field
                hide-details
                class="shrink"
                flat
                clearable
                :prepend-inner-icon="
                  jsonLookup.length > 0 ? 'mdi-barcode-scan' : 'mdi-magnify'
                "
                single-line
                v-model="search"
              ></v-text-field>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    title="Status filter"
                    small
                    class="mr-3 ml-3"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon :color="filters.length > 0 ? 'black' : 'grey '">
                      mdi-filter
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    link
                    class="text-sm-caption"
                    v-on:click="filters = []"
                    :class="filters.length == 0 ? 'font-weight-bold' : ''"
                  >
                    New
                  </v-list-item>
                  <v-list-item
                    link
                    class="text-sm-caption"
                    v-on:click="filters = ['all']"
                    :class="
                      filters.indexOf('all') >= 0 ? 'font-weight-bold' : ''
                    "
                  >
                    All
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    link
                    class="text-sm-caption"
                    v-on:click="toggleFilter('replayed')"
                    :class="
                      filters.indexOf('replayed') >= 0 ? 'font-weight-bold' : ''
                    "
                  >
                    Replayed
                  </v-list-item>
                  <v-list-item
                    link
                    class="text-sm-caption"
                    v-on:click="toggleFilter('ignored')"
                    :class="
                      filters.indexOf('ignored') >= 0 ? 'font-weight-bold' : ''
                    "
                  >
                    Ignored
                  </v-list-item>
                  <v-list-item
                    link
                    class="text-sm-caption"
                    v-on:click="toggleFilter('fixed')"
                    :class="
                      filters.indexOf('fixed') >= 0 ? 'font-weight-bold' : ''
                    "
                  >
                    Fixed
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-menu :close-on-content-click="false" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    title="Tags filter"
                    class="mr-3"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon :color="filterTags.length > 0 ? 'black' : 'grey'">
                      mdi-tag
                    </v-icon>
                  </v-btn>
                </template>
                <v-autocomplete
                  solo
                  chips
                  small-chips
                  deletable-chips
                  multiple
                  flat
                  hide-details
                  class="shrink"
                  label="Select tags..."
                  clearable
                  :items="distinctTags"
                  v-model="filterTags"
                ></v-autocomplete>
              </v-menu>
              <v-menu :close-on-content-click="false" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    title="Date filter"
                    class="mr-3"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon :color="datesFilter.length > 0 ? 'black' : 'grey '">
                      mdi-clock-time-eight
                    </v-icon>
                  </v-btn>
                </template>
                <v-date-picker v-model="datesFilter" range>
                  <v-btn text @click="datesFilter = []">Clear</v-btn>
                </v-date-picker>
              </v-menu>
              <v-menu close-on-click offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    title="Actions"
                    small
                    class="mr-3"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="grey ">
                      mdi-cogs
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    @click="batchMarkAs('ignored')"
                    link
                    class="text-sm-caption"
                  >
                    Mark {{ total }} errors as ignored
                  </v-list-item>
                  <v-list-item
                    @click="batchMarkAs('fixed')"
                    link
                    class="text-sm-caption"
                  >
                    Mark {{ total }} errors as fixed
                  </v-list-item>
                  <v-list-item
                    @click="
                      dialogTag = { batch: true };
                      showTagDialog = true;
                    "
                    link
                    class="text-sm-caption"
                  >
                    Tag {{ total }} errors
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn icon small @click="load()" title="Reload">
                <v-icon color="grey ">
                  mdi-reload
                </v-icon>
              </v-btn>
            </v-toolbar>
          </v-toolbar>
        </div>

        <v-alert v-if="hasErrors" dense outlined type="error">
          An error occurred while retrieving data
        </v-alert>
        <v-data-table
          :headers="headers"
          :items="rows"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :items-per-page="20"
          :hide-default-footer="true"
          item-key="index"
          disable-sort
          show-expand
          dense
          :loading="isLoading"
          loading-text="Loading data"
          class="elevation-1 errors-table"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-container fluid v-if="item.replays && item.replays.length > 0">
                <h2>Replays</h2>
                <v-row v-for="replay of item.replays" :key="replay.formatedTS">
                  <v-col class="font-weight-bold">{{
                    replay.formatedTS
                  }}</v-col>
                  <v-col
                    v-if="replay.response.error || replay.response.message"
                  >
                    Error:
                    {{
                      replay.response.error
                        ? replay.response.error
                        : replay.response.message
                    }}
                  </v-col>
                  <v-col
                    v-if="
                      !replay.response.error &&
                        !replay.response.message &&
                        replay.responseStatus
                    "
                    >Replayed with the response status:
                    {{ replay.responseStatus }}
                  </v-col>
                  <v-col>
                    {{ replay.comment }}
                  </v-col>
                  <v-col>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-file-document-outline
                        </v-icon>
                      </template>
                      <pre>
                      {{ replay.response }}
                        </pre
                      >
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-container>
              <v-btn
                small
                @click.stop.prevent="showPayload(item.document)"
                class="ma-4 float-right"
              >
                <v-icon small dark class="pr-2">mdi-content-copy</v-icon>
                Show Payload
              </v-btn>
              <ace-editor :content="item.document" />
            </td>
          </template>
          <template v-slot:item.date="{ item }">
            <v-icon
              title="Fixed"
              v-if="item.status && item.status.code == 'fixed'"
              small
              >mdi-check-bold</v-icon
            >
            <v-icon
              title="Ignored"
              v-if="item.status && item.status.code == 'ignored'"
              small
            >
              mdi-checkbox-multiple-blank-circle-outline
            </v-icon>
            {{ item.date }}
          </template>
          <template v-slot:item.error="{ item }">
            <div class="truncate flex">
              <v-container class="pa-0">
                <v-btn
                  :title="
                    item.lastReplay && item.lastReplay.timestamp
                      ? item.lastReplay.timestamp
                      : 'Replay'
                  "
                  light
                  small
                  icon
                  @click.stop="
                    dialogReplay = { error: item.index };
                    showReplayDialog = true;
                  "
                >
                  <v-icon
                    small
                    :color="
                      item.lastReplay && item.lastReplay.responseStatus
                        ? item.lastReplay.response.message ||
                          item.lastReplay.response.error
                          ? 'orange lighten-3'
                          : 'green'
                        : 'darkgrey'
                    "
                    >mdi-play
                  </v-icon>
                </v-btn>

                <v-btn
                  class="mr-1 "
                  light
                  small
                  icon
                  @click.stop="
                    showException = true;
                    exceptionStacktrace = item.error;
                  "
                >
                  <v-icon small dark>mdi-eye </v-icon>
                </v-btn>
                <span
                  :title="item.errorMessage"
                  class="d-inline-flex align-center"
                >
                  {{ item.errorMessage ? item.errorMessage : item.error }}
                </span>
              </v-container>
            </div>
          </template>
          <template v-slot:item.tags="{ item }">
            <v-container
              class="pa-2 d-inline-flex justify-end align-center"
              fluid
            >
              <v-chip
                :title="tag.comment ? tag.comment : ''"
                v-for="tag in item.tags"
                :key="tag.tag"
                class="mr-1"
                pill
                small
                >{{ tag.tag }}
              </v-chip>
              <v-menu offset-y close-on-content-click>
                <template v-slot:activator="{ on, attrs }">
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      light
                      small
                      icon
                      class="mr-1"
                      :class="{ 'show-tag': hover }"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small class="tagicon" color="transparent">
                        mdi-tag
                      </v-icon>
                    </v-btn>
                  </v-hover>
                </template>
                <v-list>
                  <v-list-item
                    link
                    @click.stop="
                      markAs(
                        item,
                        item.status && item.status.code == 'ignored'
                          ? undefined
                          : 'ignored'
                      )
                    "
                    class="text-sm-caption"
                  >
                    <v-icon light right small class="mr-2">
                      mdi-checkbox-multiple-blank-circle-outline
                    </v-icon>
                    {{
                      item.status && item.status.code == 'ignored'
                        ? 'Unmark'
                        : 'Mark'
                    }}
                    as ignored
                  </v-list-item>
                  <v-list-item
                    link
                    class="text-sm-caption"
                    @click.stop="
                      markAs(
                        item,
                        item.status && item.status.code == 'fixed'
                          ? undefined
                          : 'fixed'
                      )
                    "
                  >
                    <v-icon light right small class="mr-2">
                      mdi-check-bold
                    </v-icon>
                    {{
                      item.status && item.status.code == 'fixed'
                        ? 'Unmark'
                        : 'Mark'
                    }}
                    as fixed
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    link
                    class="text-sm-caption"
                    @click.stop="
                      dialogTag = { batch: false };
                      dialogTag.error = item.index;
                      showTagDialog = true;
                    "
                  >
                    <v-icon light right small class="mr-2">
                      mdi-plus-circle-outline
                    </v-icon>
                    New tag
                  </v-list-item>
                  <v-list-item
                    link
                    class="pl-6 text-sm-caption font-italic"
                    v-for="tag of item.tags"
                    :key="tag.tag"
                    @click.stop="removeTag(item, tag.tag)"
                  >
                    <v-icon light right small class="mr-2">
                      mdi-minus-circle-outline
                    </v-icon>
                    {{ tag.tag }}
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-container>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="10"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        ></v-pagination>
      </v-col>
      <v-dialog v-model="showException" max-width="1000px">
        <v-card>
          <v-card-title>
            <v-card-title>
              Error Stacktrace
            </v-card-title>
          </v-card-title>
          <v-card-text>
            <ace-editor :content="exceptionStacktrace" />
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showPayloadDialog" max-width="1000px">
        <v-card>
          <v-card-title>
            <v-card-title>
              Error Payload
            </v-card-title>
          </v-card-title>
          <v-card-text>
            <ace-editor :content="JSON.stringify(payload, null, 4)" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="showPayloadDialog = false"
            >
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="copyPayload()">
              Copy Payload
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showTagDialog" max-width="300px">
        <v-card>
          <v-card-title>
            <v-card-title>
              Add new tag
            </v-card-title>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="tagForm" lazy-validation v-model="dialogTag.isValid">
                <v-text-field
                  :rules="[v => !!v || 'Tag is required']"
                  label="Tag"
                  v-model="dialogTag.tag"
                ></v-text-field>
                <v-text-field
                  label="Comment"
                  v-model="dialogTag.comment"
                ></v-text-field>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="showTagDialog = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="addTag()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showReplayDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <v-card-title>
              Replay
            </v-card-title>
          </v-card-title>
          <v-card-text>
            <v-container fluid class="text-body-2">
              You're about to replay an error payload.
              <br /><br />
              This action can potentially cause data inconsistency issues if the
              error you're playing is too old.
              <v-text-field
                label="Comment"
                v-model="dialogReplay.comment"
              ></v-text-field>
              <v-switch
                v-model="dialogReplay.publish"
                label="Publish"
              ></v-switch>
              <span class="caption" v-if="dialogReplay.publish">
                By checking 'publish', the payload will be broadcast to
                subsequent workers.</span
              >
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="showReplayDialog = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="replay()">
              Replay
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-navigation-drawer app clipped right width="300">
      <v-toolbar-title class="ma-6 text-subtitle-1"
        >Errors Summary</v-toolbar-title
      >
      <div class="ml-4 mt-5 caption">
        <v-container
          v-for="(stat, namespace) in stats"
          :key="stat.hub"
          fluid
          class="text--secondary "
        >
          <div class="font-weight-bold text-uppercase">{{ namespace }}</div>
          <v-col class="pa-0 ma-0">
            <v-list>
              <v-row dense v-for="s of stat" :key="s.hub">
                <v-col
                  class="filter-hub"
                  :class="
                    filterHub == namespace + '-' + s.hub
                      ? 'font-weight-bold'
                      : ''
                  "
                  @click="
                    filterHub == namespace + '-' + s.hub
                      ? (filterHub = null)
                      : (filterHub = namespace + '-' + s.hub)
                  "
                >
                  {{ s.hub }}
                </v-col>
                <v-col>{{ s.count }}</v-col>
              </v-row>
            </v-list>
          </v-col>
        </v-container>
        <v-container fluid class="text--secondary ">
          <div
            v-if="statsType.length > 0"
            class="mt-3 font-weight-bold text-uppercase"
          >
            ERROR TYPES
          </div>
          <v-col class="pa-0 ma-0">
            <v-list>
              <v-row dense v-for="stat in statsType" :key="stat['_id']['err']">
                <v-col
                  class="truncate filter-hub"
                  :class="filterType == stat._id.err ? 'font-weight-bold' : ''"
                  @click="
                    filterType == stat._id.err
                      ? (filterType = null)
                      : (filterType = stat._id.err)
                  "
                  :title="stat._id.err"
                >
                  {{ stat['_id']['err'] }}
                </v-col>
                <v-col>{{ stat['count'] }}</v-col>
              </v-row>
            </v-list>
          </v-col>
        </v-container>
      </div>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import AceEditor from '@/components/AceEditor';
import { createNamespacedHelpers } from 'vuex';
import errorsService from '@/services/errors.js';

const { mapGetters, mapActions } = createNamespacedHelpers('errors/table');
const PAGE_SIZE = 20;
const { mapState: mapStateConfig } = createNamespacedHelpers('config');

export default {
  name: 'ErrorManager',
  components: { AceEditor },

  methods: {
    ...mapActions([
      'loadErrors',
      'loadStatsForHub',
      'loadStatsForType',
      'loadTags'
    ]),
    async replay() {
      this.notify('info', 'Replay request sent...');
      try {
        const data = await errorsService.replayError(this.dialogReplay);
        this.showReplayDialog = false;
        this.dialogReplay = {};
        if (data.response && (data.response.message || data.response.error)) {
          this.notify(
            'error',
            'Got an error: ' +
              (data.response.error
                ? data.response.error
                : data.response.message)
          );
        } else if (data.responseStatus) {
          this.notify(
            'info',
            'Error replayed successfully with status: ' + data.responseStatus
          );
        }
      } catch (err) {
        this.notify('error', 'Could not replay error at this time');
      }
    },
    showPayload(doc) {
      errorsService.loadPayload(JSON.parse(doc)).then(data => {
        this.showPayloadDialog = true;
        this.payload = data;
      });
    },
    copyPayload() {
      const serv = this;

      navigator.clipboard.writeText(JSON.stringify(this.payload.payload)).then(
        function() {
          serv.notify(
            'info',
            'The message payload was copied to your clipboard!'
          );
        },
        function() {
          serv.notify('error', 'Could not copy the error to your clipboard.');
        }
      );
    },
    notify(level, message) {
      this.notifyLevel = level;
      this.notifyMessage = message;
      this.showNotification = true;
    },
    markAs(item, val) {
      errorsService.markAs(item.index, val).then(this.load);
    },
    batchMarkAs(val) {
      const serv = this;
      errorsService
        .batchMarkAs(this.constructSearchQuery(), val)
        .then(function(data) {
          serv.notify(
            'info',
            'Successfully updated ' +
              data.nModified +
              '/' +
              data.n +
              ' messages!'
          );
          serv.load();
        });
    },
    async addTag() {
      this.$refs.tagForm.validate();
      if (this.dialogTag.tag && this.dialogTag.tag != '') {
        this.showTagDialog = false;
        if (!this.dialogTag.batch) {
          errorsService
            .tag(this.dialogTag.error, this.dialogTag, true)
            .then(this.load);
        } else {
          const res = await errorsService.batchTag(
            this.constructSearchQuery(),
            this.dialogTag
          );

          this.notify(
            'info',
            'Successfully tagged ' + res.nModified + ' messages!'
          );
          this.load();
        }
      }
    },
    removeTag(item, tagToRemove) {
      errorsService
        .tag(item.index, { tag: tagToRemove }, false)
        .then(this.load);
    },
    constructSearchQuery() {
      const query = {};
      this.jsonLookup = [];
      if (this.search && this.search != '') {
        query['$or'] = [{ error: { $regex: this.search, $options: 'i' } }];
        try {
          let searchObject = JSON.parse(this.search);
          for (let searchKey of Object.keys(searchObject)) {
            let searchQuery = {};
            searchQuery['payload.' + searchKey] = searchObject[searchKey];
            // must use jsonLookup along with constructSearchQuery to lookup&match 'errorsdata' before 'errors'
            this.jsonLookup.push(searchQuery);
          }
        } catch (e) {
          // do nothing
        }
      }
      const dates = [...this.datesFilter].sort();
      if (dates.length > 0) {
        let firstDate = Date.parse(dates[0] + ' 00:00:00');
        let lastDate = Date.parse(dates[0] + ' 23:59:59');
        if (dates.length == 2) {
          lastDate = Date.parse(dates[1] + ' 23:59:59');
        }
        query.storedTimestamp = { $gte: firstDate, $lte: lastDate };
      }
      if (this.filterHub) {
        query['occuredOn.eventHub.name'] = this.filterHub;
      }
      if (this.filterType) {
        query['errorType'] = this.filterType;
      }
      if (this.filters.length > 0) {
        if (this.filters.indexOf('all') < 0) {
          // NOT ALL
          query['status.code'] = { $in: this.filters };
          if (this.filters.indexOf('replayed') >= 0) {
            query['replays'] = { $exists: true };
          }
        }
      } else {
        // NEW
        query['status.code'] = { $exists: false };
        query['replays'] = { $exists: false };
      }
      if (this.filterTags.length > 0) {
        query['tags.tag'] = { $in: this.filterTags };
      }
      return query;
    },
    load() {
      this.loadErrors({
        pageSize: PAGE_SIZE,
        pageNumber: this.page,
        query: this.constructSearchQuery()
      });
      this.loadStatsForHub({ query: this.constructSearchQuery() });
      this.loadStatsForType({ query: this.constructSearchQuery() });
    },
    toggleFilter(val) {
      if (this.filters.indexOf('all') >= 0) {
        this.filters.splice(this.filters.indexOf('all'), 1);
      }
      let i = this.filters.indexOf(val);
      if (i === -1) this.filters.push(val);
      else this.filters.splice(i, 1);
    },
    showMessage(msg) {
      this.snackbarText = msg;
      this.showSnackbar = true;
    }
  },
  computed: {
    ...mapStateConfig(['entities', 'currentDivision']),
    ...mapGetters([
      'rows',
      'total',
      'errors',
      'isLoading',
      'hasErrors',
      'stats',
      'statsType',
      'distinctTags'
    ]),
    pageCount() {
      return this.total && this.total > 0
        ? Math.ceil(this.total / PAGE_SIZE)
        : 1;
    }
  },
  created() {
    this.load();
    this.loadTags();
  },
  watch: {
    currentDivision() {
      this.load();
      this.loadTags();
    },
    page() {
      this.load();
    },
    filterTags(val) {
      val && this.load();
    },
    search() {
      if ((this.search && this.search.length > 2) || !this.search) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.load();
        }, 500);
      }
    },
    filters() {
      this.load();
    },
    filterHub() {
      this.load();
    },
    filterType() {
      this.load();
    },
    datesFilter() {
      this.load();
    }
  },
  data() {
    return {
      page: 1,
      payload: null,
      showPayloadDialog: false,
      showException: false,
      showReplayDialog: false,
      showTagDialog: false,
      dialogTag: {},
      dialogReplay: {},
      jsonLookup: [],
      filterTags: [],
      exceptionStacktrace: '',
      expanded: [],
      options: {},
      filterHub: null,
      filterType: null,
      datesFilter: [],
      search: '',
      filters: [],
      singleExpand: false,
      showNotification: false,
      notifyMessage: '',
      notifyLevel: 'info',
      headers: [
        {
          text: 'date',
          value: 'date'
        },
        {
          text: 'hub',
          value: 'name'
        },
        {
          text: 'error',
          value: 'error'
        },
        {
          text: '',
          value: 'tags',
          align: 'right'
        }
      ]
    };
  }
};
</script>

<style>
[aria-expanded='true'] .tagicon,
.show-tag .tagicon {
  color: gray !important;
}

.errors-table td:last-of-type {
  padding: 0 !important;
}

.filter-hub {
  cursor: pointer;
}

.truncate {
  max-width: 34vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
